import { LocationsListTemplate } from "app/features/locations/templates/LocationsListTemplate";

export default function LocationsScreen() {
  return <LocationsListTemplate />;
}
